/* ups.icon.svg.js */

module.exports = {
    icon: `
    <svg viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path class="foreground-gl" fill-rule="evenodd" clip-rule="evenodd" d="M5.48931 2H13.972L20 8.39402V18H0V7.82259L5.48931 2ZM11.1111 11.1429H8.88889V6.57143H11.1111V11.1429ZM6.66667 13.4286V8.85714H4.44444V13.4286H6.66667ZM15.5556 8.85714H13.3333V13.4286H15.5556V8.85714Z"/>
    </svg>
    `
};
